import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { useAuth } from '../contexts/AuthContext';
import { canAccessAdminArea } from '../utils/roles';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  const isAdmin = canAccessAdminArea(user);

  if (!isAdmin) {
    return <Navigate to={user ? '/' : '/login'} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
